import React, { useEffect, useState } from 'react';
import styles from "../styles/gallerysubmodule.module.css";
import axios from 'axios';

const MediaLink = () => {
  const [mediaLinks, setMediaLinks] = useState([]);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios
      .get(`${apiBaseUrl}/documents?type=gallery&subType=media-link`)
      .then((res) => setMediaLinks(res.data))
      .catch((err) => console.error('Error fetching media links:', err));
  }, [apiBaseUrl]);

  return (
    <div className={styles.photos}>
      <h4 className={styles.friends_of_snehwan_title}>MEDIA LINKS OF SNEHWAN</h4>
      {mediaLinks.length === 0 ? (
        <p style={{ textAlign: 'center' }}>No media links found.</p>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '20px',
            padding: '20px',
          }}
        >
          {mediaLinks.map((item, index) => (
            <div key={index}>
              <p style={{ fontSize: '20px' }}>
                <span style={{ marginRight: '10px', color: '#1e40af' }}>➤</span>
                <a
                  href={item.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#1e40af', textDecoration: 'underline' }}
                >
                  {item.title.replace(/\s/g, '')} {/* Title without spaces */}
                </a>
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MediaLink;
